/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { format } from "date-fns";
import { useRecoilState } from "recoil";

import { apiGetPlatformOptions } from "../../../lib/api/platform";
import { engageState } from "../../../atoms/platform";

import Landing from "../../../components/Engage/Landing";
import EngageSideBar from "../../../components/Layout/EngageSideBar";
import EngageMenuButton from "../../../components/Layout/EngageMenuButton";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}

export default function EngageIndex() {
  const isMounted = useMounted();
  const router = useRouter();
  const { client } = router.query;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [clientState, setClientState] = useRecoilState(engageState);

  useEffect(() => {
    async function fetchClient() {
      const results = await apiGetPlatformOptions(client);
      if (results) {
        setClientState(results);
      }
    }
    if (client) {
      if (!clientState) {
        fetchClient();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  return (
    <div className="h-screen flex overflow-hidden bg-white">
      {clientState && isMounted && (
        <EngageSideBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          path="agendas"
        />
      )}
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <EngageMenuButton setSidebarOpen={setSidebarOpen} />
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className="py-6">
            <div className="px-4 sm:px-6 md:px-8 mb-2 xl:mb-4">
              <div className="pb-2 xl:pb-5 border-b border-gray-400">
                <h3 className="text-lg xl:text-2xl leading-6 font-medium text-gray-900 xl:pl-8">
                  Latest Information for {format(new Date(), "MMMM")}
                </h3>
              </div>
            </div>
            <div className="max-w-7xl 2xl:max-w-7/8 mx-auto px-4 lg:px-8">
              {isMounted && <Landing />}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
